<ion-tab-bar color="primary" slot="bottom">
  <ion-tab-button (click)="navigateTo('/home')">
    <ion-icon [name]="isActive('/home') ? 'home-sharp' : 'home-outline'"></ion-icon>
    <ion-label translate>Inicio</ion-label>
  </ion-tab-button>
  <ion-tab-button *ngIf="brandingService.isMidiadesuerte()" (click)="navigateTo('/games')">
    <ion-icon [name]="isActive('/games') ? 'dice-sharp' : 'dice-outline'"></ion-icon>
    <ion-label translate>Loterías</ion-label>
  </ion-tab-button>
  <ion-tab-button (click)="navigateTo('/wallet')">
    <ion-icon [name]="isActive('/wallet') ? 'wallet-sharp' : 'wallet-outline'"></ion-icon>
    <ion-label translate>Wallet</ion-label>
  </ion-tab-button>
  <ion-tab-button *ngIf="brandingService.isMidiadesuerte()" (click)="navigateTo('/purchase-history')">
    <ion-icon [name]="isActive('/purchase-history') ? 'ticket-sharp' : 'ticket-outline'"></ion-icon>
    <ion-label translate>Mis boletos</ion-label>
  </ion-tab-button>
  <ion-tab-button *ngIf="brandingService.isMidiadesuerte()" (click)="navigateTo('/results')">
    <ion-icon [name]="isActive('/results') ? 'list-sharp' : 'list-outline'"></ion-icon>
    <ion-label translate>Resultados</ion-label>
  </ion-tab-button>
</ion-tab-bar>
